import Vue from 'vue'
import _sa from 'sa-sdk-javascript'
import { plateForm } from '@/utils'
import api from "@/api/api_list";
import Storage from '@common/storage'
const myStorage = new Storage()
const os = plateForm().os
const app = plateForm().app

// set sensorsUrl ENV
const sensorsBase = 'https://sensors.shopshops.top/sa?project='
let sensorsEnv = 'default', ENV = 'uatdev';
if (process.env.NODE_ENV === 'production') {
  sensorsEnv = process.env.VUE_APP_SENSORS_ENV || 'refactor';
  ENV = process.env.VUE_APP_SENSORS_PUBLIC_ENV || 'prod';
}
const sensorsUrl = `${sensorsBase}${sensorsEnv}`

class Sensor {
  // constructor() {
  //     this.init()
  // }
  init() {
    // 神策初始化，为了得到登录的神策id
    _sa.init({
      server_url: sensorsUrl, // 数据接收地址
      heatmap_url: 'https://media.shopshops.top/heatmap.min.js', // 神策cdn不稳定，放到自己服务器上
      heatmap: {
        clickmap: 'default',
        collect_tags: {
          div: true
        },
        scroll_notice_map: 'default'
      },
      is_track_single_page: true,
      app_js_bridge: true, // APP内嵌H5通过APP上报埋点（会带上APP预置属性），需APP也开启对应开关
      show_log: ENV !== 'prod'
    })

    // 注册公共属性
    _sa.registerPage({
      env: ENV,
      platformType: 'H5',
      $url: window.location.href,
      appLanguge: 'en'
    })	

    // 登录
    this.login()
  }
  login(uid) {
    const { userNum = uid, userName, mobile } = myStorage.get('user_info') || {}
    if (!userNum) {
      this.logout()
      return
    }
    _sa.login(userNum)

    // 设定用户属性
    _sa.setProfile({
      userNum,
      userName,
      mobile
    })
  }
  logout() {
    _sa.logout()
  }
  presetAttr() {
    // 获取神策预置属性;
    const presetData = _sa.getPresetProperties()
    const cappSensorsData = myStorage.get('capp_sensorsData')
    const sensorsData = cappSensorsData
      ? btoa(encodeURIComponent(JSON.stringify(cappSensorsData)))
      : btoa(encodeURIComponent(JSON.stringify(presetData)))
    const presetData_base64 = sensorsData
    let os = ''
    if (plateForm().isAndroid) {
      os = 'Android'
    } else if (plateForm().isIOS) {
      os = 'iOS'
    }
    return {
      $os: os,
      $app_name: 'ShopShops哪逛',
      appLanguge: 'en',
      $app_version: '0.0.0',
      platformType: 'H5',
      // ...presetData,
      presetData_base64,
    }
  }
  autoTrack(opt = {}) {
    _sa.quick('autoTrack', { ...opt })
  }
  autoTrackSingle(opt = {}) {
    _sa.quick('autoTrackSinglePage', { ...opt })
  }
  // 通用事件追踪
  async track(param = {}) {
    const { eventId, eventParam } = param
    const sensorData = await api.sensors({
      eventId,
      eventParam
    })

    const titleMap = {
      "/home/Live":"首页直播列表",
      "/home/Upcoming":"首页预告列表",
      "/home/Replay":"首页回放列表",
      "/room":"直播详情",
      "/profile":"个人资料",
      "/cart":"购物车",
      "/goods_detail":"商品详情",
      "/order_list":"订单列表",
      "/order_detail":"订单详情",
      "/repay":"支付页",
      "/logistics":"物流详情",
      "/nimChat":"云信聊天",
      "/store":"店铺详情",
      "/anchor":"主播详情"
    }

    let title = ''
    let path = ''

    for (const key in titleMap) {
      if (Object.hasOwnProperty.call(titleMap, key)) {
        if (window.location.href.indexOf(key) > -1) {
          title = titleMap[key]
          path = key
        }
      }
    }
    
    let common = {
      time: new Date(),
      $title: title,
      path: `/app${path}`,
      $url: window.location.href,
      $is_first_time: true
    }


    const presetAttrs = _sa.getPresetProperties()
    const { code, result } = sensorData || {}
    // let requestSensorData = {}
    // if (window.requestHeader && window.requestHeader.sensorsData) {
    //     if (typeof window.requestHeader.sensorsData === 'string') {
    //         requestSensorData = {
    //             sensorsData: window.requestHeader.sensorsData
    //         }
    //     } else {
    //         requestSensorData = window.requestHeader.sensorsData
    //     }
    // }
    if (!code && result && JSON.stringify(result) !== '{}') {
      _sa.track(eventId, { ...presetAttrs, ...result,...common })
      return
    }
    _sa.track(eventId, { ...presetAttrs, ...eventParam,...common })
  }
  // 自定义点击事件
  click(param = {}) {
    const reqParam = {
      desc: '未指定点击对象描述',
      ...param
    }
    this.track({ eventId: 'commonClick', eventParam: reqParam })
  }
  // 自定义浏览事件
  view(param = {}) {
    const reqParam = {
      source: '未指定source', // 具体来源，例如：“首单”、“拼团”
      pageName: '未指定页面名称',
      ...param
    }
    this.track({ eventId: 'pageView', eventParam: reqParam })
  }
}

const saData = new Sensor()
Vue.prototype.$sa = _sa
Vue.prototype.sa = saData
export default saData
